var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGoToChatLink2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4684_434)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.0758 17.3533L1.66664 18.3333L2.64664 13.9241C2.00125 12.7169 1.66457 11.3688 1.66664 9.99996C1.66664 5.39746 5.39747 1.66663 9.99997 1.66663C14.6025 1.66663 18.3333 5.39746 18.3333 9.99996C18.3333 14.6025 14.6025 18.3333 9.99997 18.3333C8.6311 18.3354 7.28298 17.9987 6.0758 17.3533ZM6.31747 15.5925L6.86164 15.8841C7.82709 16.4001 8.9053 16.6689 9.99997 16.6666C11.3185 16.6666 12.6074 16.2756 13.7038 15.5431C14.8001 14.8105 15.6546 13.7694 16.1592 12.5512C16.6638 11.333 16.7958 9.99256 16.5385 8.69936C16.2813 7.40615 15.6464 6.21826 14.714 5.28591C13.7817 4.35356 12.5938 3.71863 11.3006 3.46139C10.0074 3.20416 8.66692 3.33618 7.44875 3.84076C6.23057 4.34535 5.18938 5.19983 4.45684 6.29616C3.7243 7.39249 3.3333 8.68142 3.3333 9.99996C3.3333 11.1116 3.60414 12.1816 4.11664 13.1383L4.40747 13.6825L3.86164 16.1383L6.31747 15.5925Z",
    fill: "#007AFF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4684_434"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoToChatLink2);
export default __webpack_public_path__ + "static/media/go_to_chat_link_2.afc3b8f2.svg";
export { ForwardRef as ReactComponent };